import { RATE_LIMITING_STATUS_ACTIONS } from '../../constants/actions';
const { VARIANT_DOWNLOADS_LIMIT_REACHED } = RATE_LIMITING_STATUS_ACTIONS;

import { AnyAction } from 'redux';

export const setVariantDownloadsLimitReached = (payload: boolean): AnyAction => ({
  type: VARIANT_DOWNLOADS_LIMIT_REACHED,
  payload,
});
